
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/equipe",
      function () {
        return require("private-next-pages/equipe.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/equipe"])
      });
    }
  